import styled from 'styled-components';

import { PageLayout } from '@thinknet-gmbh/platform-common-ui';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 17px;
`;

export const CalendarViewPool = styled.div`
  display: flex;
  height: 100%;

  & > div {
    transition: flex 0.3s ease;
    border-right: none;
  }

  & > .collapsed:last-child {
    padding-right: 0px;
  }

  .collapsed {
    flex: 1;
    overflow: inherit;
    padding-right: 30px;
  }

  .un-collapsed {
    flex: 0.0001 1 44px;
  }
`;

export const GanttWrapper = styled.div`
  height: 100%;
`;

export const HeaderGanttContainer = styled.div`
  margin-bottom: 21px;
  margin-top: 4px;
`;

export const GanttPageContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${({ isFullScreenForThreeMonthView }: { isFullScreenForThreeMonthView?: boolean }) =>
    isFullScreenForThreeMonthView
      ? `height: calc(100% - 37px);
          & > div {
            display: flex;
            justify-content: end;
            padding-bottom: 15px;
          }
        `
      : 'height: 100%;'}
`;

export const GanttContainer = styled.div`
  transition: width 0.3s ease-in-out;
  width: 320px;
  height: calc(100% - 45px);
`;

export const GanttCalendarContainer = styled.div`
  position: relative;
  height: 100%;
`;

export const GanttPageLayout = styled(PageLayout)`
  & > div:last-child {
    height: calc(100vh - 132px);
  }
`;
